import { motion } from "framer-motion";
import { Footer } from "../components/layout/Footer";
import Navbar from "../components/layout/Navbar";

const AboutPage = () => {
  const pageVariants = {
    initial: { opacity: 0, y: 20 },
    animate: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.6,
        ease: "easeInOut",
        when: "beforeChildren",
        staggerChildren: 0.2
      }
    },
    exit: { opacity: 0, y: -20 }
  };

  // Child element variants
  const childVariants = {
    initial: { opacity: 0, y: 30 },
    animate: {
      opacity: 1,
      y: 0,
      transition: { duration: 0.5, ease: "backOut" }
    }
  };

  // Image stack variants
  const imageStackVariants = {
    initial: { opacity: 0 },
    animate: {
      opacity: 1,
      transition: {
        staggerChildren: 0.2,
        delayChildren: 0.3
      }
    }
  };

  const imageItemVariants = {
    initial: { opacity: 0, x: -50 },
    animate: { opacity: 1, x: 0 }
  };

  return (
    <div>
      <Navbar />
      <motion.div
        key="about-page"
        initial="initial"
        animate="animate"
        exit="exit"
        variants={pageVariants}
        className="p-4 sm:p-8"
      >
        <div className="landing-bg bg-cover bg-no-repeat bg-center flex flex-col gap-10 items-center justify-center">
          <motion.div
            className="flex items-center justify-center flex-col"
            variants={childVariants}
          >
            <motion.h1
              className="font-bold"
              whileHover={{ scale: 1.05 }}
            >
              About us
            </motion.h1>
            <motion.p
              whileHover={{ scale: 1.02 }}
            >
              Learn what you can about us
            </motion.p>
          </motion.div>
          <motion.div
            className="flex items-center md:items-start justify-center w-full md:flex-row flex-col-reverse gap-10 md:gap-0"
            variants={childVariants}
          >
            <motion.div
              className="relative w-[60%] sm:w-[500px] mt-20 flex items-center justify-start"
              variants={imageStackVariants}
              initial="initial"
              animate="animate"
            >
              <div className="relative">
                <motion.div
                  className="absolute z-10 flex items-start justify-center flex-col gap-1"
                  variants={imageItemVariants}
                >
                  <motion.img
                    src="/assets/founder.png"
                    className="sm:w-[250px] w-[165px]"
                    alt="Founder"
                    whileHover={{ scale: 1.05 }}
                    transition={{ type: "spring", stiffness: 300 }}
                  />
                  <motion.div
                    className="flex items-start justify-center flex-col"
                    variants={childVariants}
                  >
                    <h5 className="font-medium">Davies Nzan</h5>
                    <span className="text-[#3C465F]">Founder</span>
                  </motion.div>
                </motion.div>

                <motion.div
                  className="relative sm:-top-20 -top-15 sm:left-48 left-32 flex items-start justify-center flex-col gap-1 sm:w-[250px] w-[165px]"
                  variants={imageItemVariants}
                >
                  <motion.img
                    src="/assets/cofounder.png"
                    className="w-full"
                    alt="Co-Founder"
                    whileHover={{ scale: 1.05 }}
                    transition={{ type: "spring", stiffness: 300 }}
                  />
                  <div className="flex items-end w-full justify-center flex-col">
                    <h5 className="font-medium">David Udoh</h5>
                    <span className="text-[#3C465F]">Co-Founder</span>
                  </div>
                </motion.div>
              </div>
            </motion.div>
            <motion.div
              className="w-full md:text-left text-center sm:w-[80%] md:w-[35%] flex items-start justify-center gap-3 flex-col"
              variants={childVariants}
              whileInView="animate"
              viewport={{ once: true, margin: "0px 0px -100px 0px" }}
            >
              <motion.h3
                className="text-[#7E57C2] text-center md:text-left w-full"
              >
                VISION
              </motion.h3>
              <motion.h2
                className="font-medium leading-9"
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                transition={{ delay: 0.4 }}
              >
                Amplifying individual businesses, one person at a time
              </motion.h2>
              <motion.p
                className="text-justify"
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                transition={{ delay: 0.6 }}
              >
                Jellosite empowers one person businesses all over the country to
                make more money by giving them the tools to not only amplify
                themselves, but build trust and have better work life balance.
                We do this with the help of a transparent, talented and
                hardworking team.
              </motion.p>
            </motion.div>
          </motion.div>
        </div>
      </motion.div>

      <Footer />
    </div>
  );
};

export default AboutPage;